<template>
  <div class="full-width">
    <div>{{ getTitle(cell, cell.mandatory ? 'ud-config.text.radioCellHint' : '') }}</div>
    <div class="pl-4" style="border-left: 1px solid #e0e0e0">
      <WBUDSwitchCell
        v-for="(radio, index) in radiosAsCells"
        :key="'ud-sw-' + index"
        :cell="radio"
        :namespace="namespace"
        :mIndex="mIndex"
        @change="(v, k) => cell.singleSelection && onChange(v, k)"
      />
    </div>
  </div>
</template>

<script>
import WBUDSwitchCell from './WBUDSwitchCell.vue';
import { getTitle } from './wb-common';

export default {
  components: { WBUDSwitchCell },
  props: {
    cell: { type: Object, required: true },
    namespace: { type: String, required: true },
    mIndex: { type: String, default: '' },
  },
  data: () => ({ getTitle }),
  computed: {
    input: {
      get() {
        return this.$store.state[this.namespace].formInput;
      },
      set(val) {
        this.$store.state[this.namespace].formInput = val;
      },
    },
    radiosAsCells() {
      if (this.cell && this.cell.radios) {
        return Object.keys(this.cell.radios).map((key) => {
          return { key, title: this.cell.radios[key] };
        });
      }
      if (this.cell && this.cell.radiosSorted) {
        return this.cell.radiosSorted
          .map((radio) => {
            return { key: radio.key, title: radio.title, sort: radio.sort };
          })
          .sort((a, b) => a.sort - b.sort);
      }
      return [];
    },
  },
  methods: {
    onChange(val, key) {
      //Update other switch fields if is single selection
      if (val === true) {
        if (this.cell.radios) {
          Object.keys(this.cell.radios)
            .filter((k) => k + this.mIndex != key)
            .forEach((key) => {
              const cellKey = key + this.mIndex;
              this.$set(this.input, cellKey, false);
            });
        }
        if (this.cell.radiosSorted) {
          this.cell.radiosSorted.forEach((radio) => {
            const cellKey = radio.key + this.mIndex;
            if (cellKey != key) {
              this.$set(this.input, cellKey, false);
            }
          });
        }
      }
    },
  },
  created() {
    if (this.cell.radios) {
      Object.keys(this.cell.radios).forEach((key) => {
        const cellKey = key + this.mIndex;
        this.$set(this.input, cellKey, false);
      });
    }
    if (this.cell.radiosSorted) {
      this.cell.radiosSorted.forEach((radio) => {
        const cellKey = radio.key + this.mIndex;
        if (!this.input[cellKey]) {
          this.$set(this.input, cellKey, false);
        }
      });
    }
  },
};
</script>
